import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, mergeMap } from 'rxjs';
import { ServicePathsSettings } from 'src/app/core/configuration/service-paths-settings';
import { SectionsServiceTsService } from 'src/app/pda/utils/Service/sections.service.ts.service';

@Injectable({
  providedIn: 'root'
})
export class PartyServiceTsService {

  importDatiSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  constructor(private http: HttpClient,
    private sectionService: SectionsServiceTsService) { }

  getControparti(idFascicoloPct):Observable<any> {
    return this.http.get<any>(ServicePathsSettings.URL_GET_SECTIONS(idFascicoloPct, 'parti'));
  }

  importParti(token, idFascicolo: string, idFascicoloPct: string, parti: string[]): Observable<any>{
    let req = { listaIdParti: parti };
    let url = ServicePathsSettings.URL_IMPORT_PARTI_PCT.replace("{idFascicoloPct}", idFascicoloPct);
    return this.http.post<any>(url, req).pipe(
      mergeMap(() => this.sectionService.updatePCT(token, idFascicolo, "parti"))
    );
  }

  onNextImportParti(){
    this.importDatiSubject.next(null);
  }

}
